import api from "../../../services/api";
import { errorFormater } from "../../../services/errorHandler";

const getHomeDetails = (set) => async (id) => {
  try {
    set({ isLoading: true });

    const response = await api.get(`/home/${id}/`);
    const result = response.data;
    set({
      queueDetails: result,
      queueId: id,
      isLoading: false,
    });
  } catch (error) {
    set({ isLoading: false });
    throw errorFormater(error.response);
  }
};

export default getHomeDetails;
